<script setup>
import router from '@/router/routes'
</script>

<template>
  <div class="new_app_version_alert active">
    <div class="new_app_version_alert__inner">
      <img alt="Warning" src="~@shared-images/icons/alert/light.png" class="new_app_version_alert__icon" />
      <b>A new version is available!</b>
      <button class="btn btn-secondary new_app_version_alert__button" @click="router.go()">Reload page</button>
    </div>
  </div>
</template>
